<h1 class="page-header"><i class="fa fa-plus-square" aria-hidden="true"></i> ROLE MANAGER</h1>
<div class="container-fluid">

<!-- Role table -->
  <div class="page-button">
    <button class="btn btn-primary" (click)="addNewRole()"><i class="fa fa-plus" aria-hidden="true"></i> ADD NEW ROLE</button>

    <div class="btn-group edgefinityHeader">
      <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-wrench" aria-hidden="true"></i> ACTIONS <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li><a (click)="duplicateUserRoles()"><i class="fa fa-clone" aria-hidden="true"></i> DUPLICATE</a></li>
        <li><a (click)="deleteUserRoleQuery()"><i class="fa fa-times" aria-hidden="true"></i> DELETE</a></li>
      </ul>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table tablesorter tablesorter-default table-hover" id="roleTable">
      <thead>
      <tr>
        <th class="table-checkbox">
          <div class="checkbox checkbox-inline">
            <input type="checkbox" id="selectAllRoles" />
          </div>
        </th>
        <th>ROLE NAME</th>
        <th>DESCRIPTION</th>
      </tr>
      </thead>
      <tbody id="roleTableBody" *ngFor="let role of roles">
        <tr>
          <td><div class="checkbox checkbox-inline"><input type="checkbox" [(ngModel)]="userRoleCheckbox[role.id]" class="styled"><label for="checkbox"></label></div></td>
          <td (click)="showRole(role)">{{ role.name }}</td>
          <td (click)="showRole(role)">{{ role.description}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-rolemanager-dialog #roleManagerDialog></app-rolemanager-dialog>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>